import React from 'react';

import { Documents } from '../components/Documents/Documents';

const DocumentsOverview = () => {
  return <Documents />;
};

export default DocumentsOverview;
